const services = [
  {
    icon: 'ri-building-line',
    title: 'Office & Workspace Cleaning',
    description:
      'Comprehensive daily, weekly, or monthly cleaning for open-plan offices, private suites, and co-working spaces. We handle desks, floors, kitchens, and restrooms.',
    features: ['Daily sanitization', 'Desk & surface wipe-down', 'Restroom deep clean', 'Waste management'],
    image:
      'https://public.readdy.ai/ai/img_res/8299426160aaa80fc82c98e50ea563a3.jpg',
  },
  {
    icon: 'ri-hospital-line',
    title: 'Medical & Healthcare Facilities',
    description:
      'Certified disinfection protocols for clinics, labs, and healthcare offices. We comply with all health and safety standards to maintain sterile environments.',
    features: ['Hospital-grade disinfectants', 'Cross-contamination prevention', 'Biohazard disposal', 'Compliance certified'],
    image:
      'https://readdy.ai/api/search-image?query=clean%20bright%20medical%20clinic%20hallway%20with%20white%20walls%2C%20polished%20floors%2C%20sterile%20environment%2C%20professional%20healthcare%20facility%2C%20spotless%20surfaces%2C%20modern%20hospital%20interior%2C%20neutral%20tones%2C%20pristine%20and%20hygienic&width=600&height=400&seq=svc002&orientation=landscape',
  },

  {
    icon: 'ri-tools-line',
    title: 'Post-Construction Cleanup',
    description:
      'Thorough removal of construction debris, dust, and residue. We prepare your new or renovated space for immediate occupancy.',
    features: ['Debris removal', 'Dust & particle cleanup', 'Window & fixture cleaning', 'Final inspection ready'],
    image:
      'https://readdy.ai/api/search-image?query=freshly%20renovated%20commercial%20space%20after%20construction%20cleanup%2C%20clean%20empty%20room%20with%20polished%20floors%2C%20bright%20natural%20light%2C%20spotless%20walls%2C%20modern%20interior%2C%20neutral%20tones%2C%20ready%20for%20occupancy%2C%20pristine%20and%20tidy&width=600&height=400&seq=svc004&orientation=landscape',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Green & Eco-Friendly Cleaning',
    description:
      'Sustainable cleaning using certified eco-friendly products. Ideal for companies with environmental commitments and LEED-certified buildings.',
    features: ['Non-toxic products', 'LEED compatible', 'Reduced water usage', 'Recyclable materials'],
    image:
      'https://readdy.ai/api/search-image?query=eco-friendly%20green%20office%20cleaning%20with%20natural%20light%2C%20plants%2C%20sustainable%20environment%2C%20clean%20modern%20workspace%2C%20green%20and%20white%20tones%2C%20minimalist%20corporate%20interior%2C%20spotless%20surfaces%2C%20natural%20and%20fresh%20atmosphere&width=600&height=400&seq=svc005&orientation=landscape',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Scheduled Maintenance Plans',
    description:
      'Flexible recurring cleaning contracts — daily, weekly, or monthly. Dedicated account managers ensure consistent quality every visit.',
    features: ['Flexible scheduling', 'Dedicated account manager', 'Quality audits', 'Priority support'],
    image:
      'https://readdy.ai/api/search-image?query=professional%20cleaning%20team%20in%20corporate%20office%20lobby%2C%20uniformed%20staff%2C%20polished%20marble%20floors%2C%20bright%20modern%20interior%2C%20spotless%20reception%20area%2C%20neutral%20tones%2C%20professional%20commercial%20cleaning%20service%2C%20pristine%20environment&width=600&height=400&seq=svc006&orientation=landscape',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-28 bg-[#f8f9f7]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span
              className="text-[#4caf7d] text-xs font-semibold tracking-widest uppercase"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              What We Do
            </span>
            <h2
              className="text-3xl md:text-5xl font-bold text-[#1a3a2a] mt-2 leading-tight"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              Professional Cleaning<br />
              <span className="text-[#4caf7d]">Solutions</span>
            </h2>
          </div>
          <p className="text-gray-500 text-sm md:text-base max-w-sm leading-relaxed">
            Tailored cleaning programs for every type of corporate environment — from startups to Fortune 500 companies.
          </p>
        </div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300 border border-gray-100"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-[#e8f5ee] rounded-xl mb-4">
                  <i className={`${service.icon} text-[#4caf7d] text-lg`}></i>
                </div>
                <h3
                  className="text-base font-bold text-[#1a3a2a] mb-2"
                  style={{ fontFamily: "'Syne', sans-serif" }}
                >
                  {service.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{service.description}</p>
                <ul className="flex flex-col gap-1.5">
                  {service.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-xs text-gray-600">
                      <i className="ri-check-line text-[#4caf7d]"></i>
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
